// Mock data for Dr. Mamtesh Gupta website clone

export const siteInfo = {
  name: "Dr. Mamtesh Gupta",
  tagline: "Mamtesh Gupta Heart Center",
  phone: "9837082071",
  phoneFull: "+91- 9837082071",
  email: "mamteshgupta@yahoo.com",
  address: "B-27, Saket, Meerut, Uttar Pradesh - 250001",
  fullAddress: "Basement B-27, Near State Bank, Saket, Meerut, Uttar Pradesh - 250001",
  hours: {
    weekday: "Mon - Sat: 11.00am - 5.00pm",
    sunday: "Sunday : Closed",
    emergency: "Emergency - 24 Hours",
  },
  socials: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
  },
};

export const heroSlides = [
  {
    id: 1,
    image: "https://images.pexels.com/photos/5207102/pexels-photo-5207102.jpeg",
    eyebrow: "Dr. Mamtesh Gupta",
    titleLines: ["Advanced Cardiac Care,", "Delivered with Heart"],
    subtitle: "Innovative Cardiac Solutions, Personalized Care \u2013 Dr. Mamtesh Gupta",
    ctaText: "See Our Services",
    ctaLink: "/expertise",
  },
  {
    id: 2,
      image: "/drmamtesh.webp",
    eyebrow: "Dr. Mamtesh Gupta",
    titleLines: ["Expert Cardiovascular Care,", "Compassionate Healing"],
    subtitle: "\u2013 Dr. Mamtesh Gupta, Leading Cardiologist in Meerut",
    ctaText: "Book Appointment",
    ctaLink: "/contact",
  },
  {
    id: 3,
    image: "https://images.pexels.com/photos/5207116/pexels-photo-5207116.jpeg",
    eyebrow: "Dr. Mamtesh Gupta",
    titleLines: ["Your Heart Deserves the Best", "\u2013 Trusted Care"],
    subtitle: "Where Expertise Meets Compassion \u2013 Dr. Mamtesh Gupta, Your Heart Specialist",
    ctaText: "See Our Services",
    ctaLink: "/expertise",
  },
];

export const featureStrip = [
  "Expert Medical Qualifications",
  "Advanced Cardiac Procedures",
  "State-of-the-Art Diagnostic Equipment",
  "Comprehensive Heart Disease Management",
];

export const aboutShort = {
  heading: "Dr. Mamtesh Gupta - Senior consultant Cardiologist",
  paragraph:
    "Dr. Mamtesh Gupta is a renowned cardiologist based in Meerut, known for her exceptional expertise and compassionate approach to heart care. With years of experience in diagnosing and treating a wide range of cardiovascular conditions, she integrates cutting-edge technology with the latest medical advancements to deliver optimal outcomes. Dr. Gupta is deeply committed to personalized patient care, offering tailored treatment plans that address each individual\u2019s unique needs. From preventive cardiology to complex interventional procedures, she strives to enhance heart health and improve her patients\u2019 overall quality of life.",
    image: "/drmamtesh.webp",
  highlights: [
    {
      title: "Gold Medalist and AIIMS-Trained",
      text: "Dr. Mamtesh Gupta's exceptional educational background sets her apart as a leading cardiologist in the region.",
    },
    {
      title: "Comprehensive Care",
      text: "From diagnosis to treatment and follow-up, Dr. Mamtesh Gupta provides holistic care to ensure long-term heart health.",
    },
    {
      title: "Patient-Focused",
      text: "Her approach prioritizes the individual needs of each patient, with a focus on improving quality of life and cardiovascular wellness.",
    },
  ],
};

export const aboutFull = {
  heading: "Dr. Mamtesh Gupta, DM - Cardiology",
  paragraphs: [
    "Dr. Mamtesh Gupta is a distinguished cardiologist based in Meerut, renowned for her extensive expertise in diagnosing, treating, and managing various heart conditions. With years of dedicated experience in the field of cardiology, Dr. Gupta has established herself as a trusted healthcare provider committed to improving heart health and enhancing patients' well-being.",
    "Dr. Mamtesh Gupta holds a prestigious DM in Cardiology, showcasing her advanced knowledge and specialized training in cardiovascular care. Her extensive academic background, combined with her dedication to staying updated with the latest advancements in cardiology, enables her to offer cutting-edge treatments tailored to each patient's unique needs. Dr. Gupta has also attended numerous national and international medical conferences, ensuring she integrates the latest innovations in cardiac care into her practice.",
    "For individuals seeking expert cardiac care in Meerut, Dr. Mamtesh Gupta offers comprehensive services aimed at improving heart health and enhancing quality of life. Schedule your consultation today and take the first step toward a healthier heart.",
  ],
  mission:
    "Dr. Mamtesh Gupta\u2019s mission is to provide exceptional, compassionate, and evidence-based cardiac care to her patients. She is dedicated to delivering accurate diagnoses and personalized treatment plans, educating patients about lifestyle changes that can prevent heart-related complications, and collaborating with multidisciplinary teams to provide holistic care for patients with complex heart conditions.",
  vision:
    "Dr. Mamtesh Gupta envisions a future where heart disease prevention, early diagnosis, and innovative treatment strategies improve the overall well-being of individuals in Meerut and beyond. Her vision is to create a healthier society by promoting cardiovascular awareness, empowering patients to take proactive steps toward heart care, and ensuring access to advanced treatment methods for all.",
};

export const services = [
  {
    slug: "coronary-angiography",
    title: "Coronary Angiography",
    short: "Coronary Angiography is an integral part of the general procedure of Catheterization.",
    long: "Coronary angiography is a diagnostic procedure that uses contrast dye and special X-rays to show the inside of the coronary arteries. It is performed to detect blockages or narrowing of the arteries that supply blood to the heart muscle. The procedure helps cardiologists determine whether further treatment such as angioplasty or bypass surgery is required.",
  },
  {
    slug: "coronary-angioplasty",
    title: "Coronary Angioplasty",
    short: "Coronary angioplasty is a method through which a doctor opens the blocked arteries of the heart.",
    long: "Coronary angioplasty (also called percutaneous coronary intervention) is a minimally invasive procedure used to open clogged or narrowed coronary arteries. A small balloon catheter is inserted into the artery and inflated to widen the passage, often followed by placement of a stent to keep the artery open and restore healthy blood flow to the heart.",
  },
  {
    slug: "aicd-implantation",
    title: "AICD Implantation",
    short: "AICD (Automatic Implantable Cardioverter Defibrillator) is one of the procedures that relieve life-threatening arrhythmias.",
    long: "An Automatic Implantable Cardioverter Defibrillator (AICD) is a small device placed under the skin near the chest. It continuously monitors heart rhythms and delivers electric shocks when it detects dangerous arrhythmias, helping prevent sudden cardiac arrest in high-risk patients.",
  },
  {
    slug: "tavr",
    title: "TAVR",
    short: "TAVR is a unique way with which our doctors make sure to remove the affected aortic valve.",
    long: "Transcatheter Aortic Valve Replacement (TAVR) is a minimally invasive procedure used to replace a narrowed aortic valve that fails to open properly. Instead of open-heart surgery, doctors deliver a new valve through a catheter, which is especially helpful for patients at higher risk for traditional surgery.",
  },
  {
    slug: "pacemaker",
    title: "Pacemaker",
    short: "From cutting-edge pacemakers to advanced defibrillators, we offer expertly performed implantations.",
    long: "A pacemaker is a small device implanted in the chest to help control abnormal heart rhythms. It uses electrical pulses to prompt the heart to beat at a normal rate, helping patients who suffer from bradycardia, heart block, or other rhythm disorders maintain a healthier quality of life.",
  },
  {
    slug: "echo",
    title: "Echo",
    short: "Echocardiography uses sound waves to produce live images of the heart and assess its function.",
    long: "An echocardiogram (Echo) is a non-invasive ultrasound test that produces detailed images of the heart\u2019s chambers, valves, and surrounding structures. It helps cardiologists evaluate heart function, detect abnormalities, and guide treatment decisions for a wide range of cardiac conditions.",
  },
  {
    slug: "valve-surgery",
    title: "Valve Surgery",
    short: "Valve surgery is a procedure to repair or replace damaged heart valves, restoring proper blood flow.",
    long: "Heart valve surgery is performed to repair or replace valves that are not functioning properly due to disease or damage. Depending on the patient\u2019s condition, surgeons may perform valve repair, mechanical valve replacement, or bioprosthetic valve replacement to restore normal blood flow through the heart.",
  },
  {
    slug: "ecg",
    title: "ECG",
    short: "Records the heart\u2019s electrical activity, helping diagnose heart conditions and irregular rhythms.",
    long: "An Electrocardiogram (ECG) is a quick, painless test that records the electrical signals of your heart. It is commonly used to detect heart problems such as arrhythmias, heart attacks, and other conditions that affect the cardiovascular system.",
  },
  {
    slug: "holter-test",
    title: "Holter Test",
    short: "A portable, non-invasive test that records your heart\u2019s electrical activity continuously over 24 to 48 hours.",
    long: "A Holter test, also known as Holter monitoring, is a continuous recording of the heart\u2019s electrical activity over 24 to 48 hours. It helps cardiologists identify irregular heart rhythms that may not appear during a regular ECG, allowing for more accurate diagnosis and treatment planning.",
  },
  {
    slug: "abpm-test",
    title: "ABPM Test",
    short: "Ambulatory Blood Pressure Monitoring records blood pressure at regular intervals over a 24-hour period.",
    long: "Ambulatory Blood Pressure Monitoring (ABPM) is a non-invasive test that measures blood pressure at regular intervals throughout the day and night. It provides a comprehensive picture of blood pressure changes and helps cardiologists diagnose hypertension and adjust treatment effectively.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Ravi Sharma",
    city: "Meerut",
    text: "I am extremely grateful to Dr. Mamtesh Gupta for her exceptional care. After suffering from high blood pressure and chest pain, I consulted Dr. Gupta, and she immediately put me at ease with her thorough examination and clear explanations.",
  },
  {
    id: 2,
    name: "Ankit Verma",
    city: "Meerut",
    text: "Dr. Mamtesh Gupta is a fantastic doctor. I had been struggling with irregular heartbeats and was very anxious about my health. Dr. Gupta listened patiently, explained the situation in detail, and assured me that I would be okay with the right treatment.",
  },
  {
    id: 3,
    name: "Priya Singh",
    city: "Meerut",
    text: "From the very first consultation, Dr. Gupta made me feel comfortable. She took the time to understand my concerns and explained every step of my treatment with care. Highly recommended for anyone looking for a trusted cardiologist.",
  },
  {
    id: 4,
    name: "Sunita Devi",
    city: "Meerut",
    text: "Dr. Mamtesh Gupta provided outstanding cardiac care for my mother. Her diagnosis was accurate and the treatment plan worked wonders. We are forever thankful for her compassionate approach.",
  },
];

export const stats = [
  { value: 22, suffix: "", label: "Years Of Experience" },
  { value: 100000, suffix: "", label: "Happy Patients" },
  { value: 100, suffix: "", label: "Completed Surgeries" },
  { value: 10, suffix: "", label: "Awards" },
];

export const articles = [
  {
    slug: "structural-heart-disease",
    day: "08",
    month: "Jun 24",
    author: "Dr. Mamtesh Gupta",
    title: "Structural heart disease \u2013 an overview",
    image: "https://images.unsplash.com/photo-1618939304347-e91b1f33d2ab",
    excerpt:
      "Structural heart disease refers to defects or abnormalities of the heart\u2019s valves, walls, or chambers. Learn how modern cardiology helps diagnose and treat these conditions.",
    body: [
      "Structural heart disease (SHD) refers to a group of conditions that affect the valves, walls, chambers, or major vessels of the heart. These conditions can be present from birth (congenital) or develop later in life due to ageing, infection, or wear and tear.",
      "Common forms include valve stenosis, valve regurgitation, atrial septal defects, and patent foramen ovale. Modern cardiology offers a wide range of catheter-based and surgical options to repair or replace damaged structures with minimal invasiveness.",
      "Early detection through echocardiography and timely intervention can significantly improve quality of life and long-term outcomes for patients with structural heart disease.",
    ],
  },
  {
    slug: "non-invasive-heart-diagnosis",
    day: "08",
    month: "Sept 24",
    author: "Dr. Mamtesh Gupta",
    title: "Advancements in non-invasive diagnostic techniques for heart disease",
    image: "https://images.unsplash.com/photo-1623134915837-d2fdb4f59035",
    excerpt:
      "From advanced echocardiography to cardiac MRI and CT angiography, non-invasive testing has transformed how heart conditions are detected and managed.",
    body: [
      "Modern cardiology has been revolutionised by a new generation of non-invasive diagnostic tools. Techniques such as 3D echocardiography, cardiac MRI, and CT coronary angiography now provide highly detailed images of the heart without the need for surgical intervention.",
      "These advancements allow for earlier diagnosis, more accurate risk stratification, and better treatment planning. They also significantly reduce procedural risks and patient discomfort.",
      "For patients, this means quicker results, fewer hospital visits, and personalised care plans built around precise data about their heart\u2019s structure and function.",
    ],
  },
  {
    slug: "scad-heart-condition",
    day: "08",
    month: "Nov 24",
    author: "Dr. Mamtesh Gupta",
    title: "A Serious Heart Condition Known as SCAD",
    image: "https://images.pexels.com/photos/8352120/pexels-photo-8352120.jpeg",
    excerpt:
      "Spontaneous Coronary Artery Dissection (SCAD) is a rare but serious cause of heart attack, especially in younger women. Awareness and early care are key.",
    body: [
      "Spontaneous Coronary Artery Dissection (SCAD) is an emergency condition in which a tear forms in one of the blood vessels of the heart. It can slow or block blood flow, causing a heart attack, abnormal heart rhythms, or sudden death.",
      "SCAD most commonly affects women in their 40s and 50s, often those without traditional risk factors for heart disease. Triggers may include intense emotional stress, intense exercise, or hormonal changes.",
      "Quick recognition of symptoms such as chest pain, shortness of breath, sweating, or pain radiating to the arm or jaw is critical. Immediate medical attention can save lives and dramatically improve outcomes.",
    ],
  },
];

export const serviceOptionsForForm = [
  "Echo",
  "Coronary Angiography",
  "Coronary Angioplasty",
  "Pacemaker Implantation",
  "Valve Surgery",
  "ECG",
  "Holter Test",
  "ABPM Test",
];
